import type { CustomChartSerie } from "@tokenterminal/tt-analytics-api-types/dist/api/customChart"
import { useMemo } from "react"
import { useThemeContext } from "../../../../ui/theme/ThemeContext"
import type { ChartSerieColor } from "../../tt-ui-chart/Chart"
import { SERIE_TYPES } from "../../types"
import { getColorPaletteColorVariableById, getComputedVariableColor } from "../../utils/colors"

export function Symbol({
  serieType,
  color,
}: {
  serieType: CustomChartSerie["chart_type"]
  color: ChartSerieColor
}) {
  const { theme } = useThemeContext()
  // biome-ignore lint/correctness/useExhaustiveDependencies: theme must trigger recomputation because getComputedVariableColor reads CSS variables that change with theme
  const parsedColor = useMemo(
    () => getComputedVariableColor(getColorPaletteColorVariableById(color) || color),
    [color, theme],
  )

  switch (serieType) {
    case SERIE_TYPES.LINE: {
      return (
        <svg
          width="10 "
          height="2"
          viewBox="0 0 5 1"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <title>Line chart legend symbol</title>
          <line x1="0" y1="0.5" x2="5" y2="0.5" stroke={parsedColor} strokeWidth="1" />
        </svg>
      )
    }
    default: {
      return (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <title>Chart legend symbol</title>
          <rect x="0" y="0" width="12" height="12" fill={parsedColor} rx="1" ry="1"></rect>
        </svg>
      )
    }
  }
}
